import { PAYMENTS_SECTIONS_ROUTES } from './permissions.model';

export enum PAYMENTS_META_TITLES {
  PS_MANAGEMENT = 'PS Management',
  CREATE_GEO_MULTI_METHOD = 'Create geo multi method',
  GEO_MULTI_METHOD = 'Multi method settings',
  TRANSACTIONS = 'Transactions',
  CASHIER_SETTINGS = 'Cashier settings',
  PSP_SORTING = 'PSP sorting',
  CURRENCY = 'Currency',
  PSP_TAGS = 'PSP tags',
  LOGS = 'Logs',
  LIMIT_EXCEPTIONS_UPLOAD = 'Limit exceptions upload',
}

export const PAYMENTS_SECTIONS_ROUTES_META_TITLES = {
  [PAYMENTS_SECTIONS_ROUTES.PS_MANAGEMENT]: PAYMENTS_META_TITLES.PS_MANAGEMENT,
  [PAYMENTS_SECTIONS_ROUTES.CREATE_GEO_MULTI_METHOD_PAGE]: PAYMENTS_META_TITLES.CREATE_GEO_MULTI_METHOD,
  [PAYMENTS_SECTIONS_ROUTES.GEO_MULTI_METHOD_PAGE]: PAYMENTS_META_TITLES.GEO_MULTI_METHOD,
  [PAYMENTS_SECTIONS_ROUTES.TRANSACTIONS]: PAYMENTS_META_TITLES.TRANSACTIONS,
  [PAYMENTS_SECTIONS_ROUTES.CASHIER_SETTINGS]: PAYMENTS_META_TITLES.CASHIER_SETTINGS,
  [PAYMENTS_SECTIONS_ROUTES.PSP_SORTING]: PAYMENTS_META_TITLES.PSP_SORTING,
  [PAYMENTS_SECTIONS_ROUTES.CURRENCY]: PAYMENTS_META_TITLES.CURRENCY,
  [PAYMENTS_SECTIONS_ROUTES.PSP_TAGS]: PAYMENTS_META_TITLES.PSP_TAGS,
  [PAYMENTS_SECTIONS_ROUTES.LOGS]: PAYMENTS_META_TITLES.LOGS,
  [PAYMENTS_SECTIONS_ROUTES.LIMIT_EXCEPTIONS_UPLOAD]: PAYMENTS_META_TITLES.LIMIT_EXCEPTIONS_UPLOAD,
};
